import { ErrorHandler, Injectable } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { filter } from "rxjs/operators";

type CallbackFunction<T = any> = (event: T) => void;

type NewableType<T> = new (...args: any[]) => T;

@Injectable({
    providedIn: 'root'
})

export class EventService {

    private readonly errorHandler: ErrorHandler;
    private readonly eventStream: Subject<any>;

    constructor(errorHandler: ErrorHandler) {
        this.errorHandler = errorHandler;
        this.eventStream = new Subject();
    }

    public emit(event: any): void {
        this.eventStream.next(event);
    }

    public on<T>(
        typeFilter: NewableType<T>,
        callback: CallbackFunction<T>,
        callbackContext: any = null
    ): Subscription {
        let subscription = this.eventStream
            .pipe(
                filter(
                    (event: any): boolean => {
                        return (event instanceof typeFilter);
                    }
                )
            )
            .subscribe(
                (event: T): void => {
                    try {
                        callback.call(callbackContext, event);
                    } catch (error) {
                        this.errorHandler.handleError(error);
                    }
                }
            );
        return (subscription);
    }

    public subscribe(
        callback: CallbackFunction,
        callbackContext: any = null
    ): Subscription {
        let subscription = this.eventStream.subscribe(
            (event: any): void => {
                try {
                    callback.call(callbackContext, event);
                } catch (error) {
                    this.errorHandler.handleError(error);
                }
            }
        );
        return (subscription);
    }

    public unsubscribe(): this {
        this.eventStream.unsubscribe();
        return (this);
    }
}